module.exports = __webpack_public_path__ + "static/media/elpis.1f290fe5.jpg";